import { createContext, useContextSelector } from '@fluentui/react-context-selector';
import * as React from 'react';
import { createCarouselStore } from './createCarouselStore';
export const carouselContextDefaultValue = {
    store: createCarouselStore(),
    value: null,
    selectPageByDirection: ()=>{
    /** noop */ },
    selectPageByValue: ()=>{
    /** noop */ }
};
const CarouselContext = createContext(undefined);
export const CarouselProvider = CarouselContext.Provider;
export const useCarouselContext_unstable = (selector)=>useContextSelector(CarouselContext, (ctx = carouselContextDefaultValue)=>selector(ctx));
